/**
 *
 */

export function buildWhere(template: string, form: Record<string, string>) {
    const withHelpers = template.replace(/\{(\w+)__(!)?FIRSTWORD\}/g, (_, name, not) => {
        const v = (form[name] || "").trim();
        if (!v) return "";
        const [first, ...rest] = v.split(/\s+/);
        return not ? rest.join(" ") : first;
    });
    return withHelpers.replace(/\{(\w+)\}/g, (_, name) => (form[name] ?? ""));
}
